import { useState, useMemo } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthContextProvider from "./context";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./react-query";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { getMsalConfig } from "./helpers";
// import { HTML5Backend } from "react-dnd-html5-backend";
// import { DndProvider } from "react-dnd";
// import EnvironmentSelector from "./modules/Environment";

const MainApp = () => {
  const [environment, setEnvironment] = useState("NMFB");

  const msalInstance = useMemo(() => {
    const config = getMsalConfig(environment);
    return new PublicClientApplication(config);
  }, [environment]);

  return (
    <QueryClientProvider client={queryClient}>
      {/* <DndProvider backend={HTML5Backend}> */}
      <AuthContextProvider>
        <MsalProvider instance={msalInstance}>
          {/* <EnvironmentSelector onChange={setEnvironment} /> */}
          <App />
        </MsalProvider>
      </AuthContextProvider>
      {/* </DndProvider> */}
    </QueryClientProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(<MainApp />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
